import { parseDuration } from '@/core/utils/products';

export const durations = () => {
  return [
    {
      label: '15min',
      code: 15,
    },
    {
      label: '30min',
      code: 30,
    },
    {
      label: '45min',
      code: 45,
    },
    {
      label: '1h',
      code: 60,
    },
    {
      label: '1h15min',
      code: 75,
    },
    {
      label: '1h30min',
      code: 90,
    },
    {
      label: '1h45min',
      code: 105,
    },
    {
      label: '2h',
      code: 120,
    },
  ];
};

export const buffers = () => {
  return [
    {
      label: 'None',
      code: 0,
    },
    {
      label: '5min',
      code: 5,
    },
    {
      label: '10min',
      code: 10,
    },
    {
      label: '15min',
      code: 15,
    },
    {
      label: '30min',
      code: 30,
    },
    {
      label: '45min',
      code: 45,
    },
    {
      label: '1h',
      code: 60,
    },
  ];
};

export const reminders = () => {
  return [
    {
      label: '5min before',
      code: 5,
    },
    {
      label: '10min before',
      code: 10,
    },
    {
      label: '15min before',
      code: 15,
    },
    {
      label: '30min before',
      code: 30,
    },
    {
      label: '45min before',
      code: 45,
    },
    {
      label: '1h before',
      code: 60,
    },
    {
      label: '1h15min before',
      code: 75,
    },
    {
      label: '1h30min before',
      code: 90,
    },
    {
      label: '1h45min before',
      code: 105,
    },
    {
      label: '2h before',
      code: 120,
    },
    {
      label: '2h30min before',
      code: 150,
    },
    {
      label: '3h before',
      code: 180,
    },
    {
      label: '4h before',
      code: 240,
    },
    {
      label: '8h before',
      code: 480,
    },
    {
      label: '12h before',
      code: 720,
    },
    {
      label: '1 day before',
      code: 1440,
    },
    {
      label: '2 days before',
      code: 2880,
    },
    {
      label: '3 days before',
      code: 4320,
    },
    {
      label: '4 days before',
      code: 5760,
    },
    {
      label: '5 days before',
      code: 7200,
    },
    {
      label: '6 days before',
      code: 8640,
    },
    {
      label: '1 week before',
      code: 10080,
    },
    {
      label: '2 weeks before',
      code: 20160,
    },
  ];
};

export const meetingTypeDurationOptionCreated = option => {
  try {
    const duration = parseDuration(option.label);
    option.code = duration;
  } catch (error) {
    console.log(error);
  }
};
